import {
    AppLogo,
    AuthenticationRequired,
    CLIENT_ID,
    DemoResolver,
    LoginLayout,
    LoginPage,
    NavigationLayout,
    SUPPORT_PORTAL_LINK,
    UnauthorizedPage,
    useService,
    useUser,
} from '@insight2profit/drive-app';
import { AnalyticsSelectReport, ProvideI2pAnalytics } from '@price-for-profit/analytics';
import { useSnackbar } from 'notistack';
import { Navigate, Outlet, useNavigate, useRoutes } from 'react-router-dom';
import { ROUTES } from 'routing';
import clientLogo from 'assets/insight-logo.png';
// import loginClientLogoSrc from '../assets/path-to-client-logo.png;
import { AnalyticsResolver } from 'analytics';
import insightDriveAccountLogo from 'assets/insight-drive-account-logo.svg';
import { Breadcrumbs, Typography } from '@mui/material';

const isProd = process.env.NODE_ENV === 'production';

const headerClientLogo = <AppLogo src={clientLogo} alt='client logo' />;
const loginClientLogo = <AppLogo src={`${process.env.PUBLIC_URL}/favicon-32x32.png`} alt='client login logo' />;
// const loginClientLogo = <AppLogo src={loginClientLogoSrc} alt='logo client login logo' />;
const insightLoginLogo = <AppLogo src={insightDriveAccountLogo} alt='insight logo' maxHeight='30px' />;
const driveToProfitLogo = (
    <AppLogo src={`${process.env.PUBLIC_URL}/DRIVEtoPROFIT_Color.png`} alt='drive to profit logo' maxHeight='50px' />
);

export function AppRoutes() {
    return useRoutes([
        {
            element: <Login />,
            children: [
                {
                    path: ROUTES.login,
                    element: (
                        <LoginPage
                            tabTitle='Lipari account Login'
                            insightLoginLogo={insightLoginLogo}
                            clientLogo={loginClientLogo}
                            loginRedirectRoute={ROUTES.analytics}
                        />
                    ),
                },
            ],
        },
        {
            element: <Private />,
            children: [
                {
                    path: ROUTES.demo,
                    element: <DemoResolver />,
                },
            ],
        },
        {
            element: <PrivateAnalytics />,
            children: [
                {
                    path: ROUTES.analytics,
                    element: <AnalyticsResolver />,
                },
            ],
        },
        {
            path: ROUTES.unauthorized,
            element: <Unauthorized />,
        },
        {
            path: '*',
            element: <Navigate to={ROUTES.login} replace />,
        },
    ]);
}

function Unauthorized() {
    const {
        appConfig: { serviceBaseUrl },
    } = useService();

    return (
        <UnauthorizedPage
            supportPortalLink={SUPPORT_PORTAL_LINK}
            logo={headerClientLogo}
            driveLogo={insightLoginLogo}
            serviceBaseUrl={serviceBaseUrl}
        />
    );
}

function Login() {
    const {
        appConfig: { serviceBaseUrl },
    } = useService();

    return (
        <LoginLayout serviceBaseUrl={serviceBaseUrl}>
            <Outlet />
        </LoginLayout>
    );
}
function PrivateAnalytics() {
    const user = useUser();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const {
        appConfig: { appId, serviceBaseUrl },
        eventService,
        authorizationService,
        powerBiService,
    } = useService();
    return (
        <AuthenticationRequired>
            <ProvideI2pAnalytics
                prerequisites={{
                    services: {
                        eventService,
                        authorizationService,
                        powerBiService,
                    },
                    appInfo: {
                        applicationId: appId,
                        clientId: CLIENT_ID,
                        userId: user?.id || '',
                        appName: 'Lipari Account App',
                    },
                    navigate,
                }}
                options={{
                    snackbar: {
                        enqueueSnackbar,
                    },
                }}
            >
                <NavigationLayout
                    useLocal={!isProd}
                    toolbar={{
                        leftComponent: (
                            <Breadcrumbs aria-label='breadcrumb' color='#aaa'>
                                <Typography color='inherit'>Analytics</Typography>
                                <AnalyticsSelectReport />
                            </Breadcrumbs>
                        ),
                    }}
                    applicationId={appId}
                    logo={headerClientLogo}
                    serviceBaseUrl={serviceBaseUrl}
                    footerLogo={driveToProfitLogo}
                    navigation={{
                        supportPortalLink: SUPPORT_PORTAL_LINK,
                    }}
                >
                    <Outlet />
                </NavigationLayout>
            </ProvideI2pAnalytics>
        </AuthenticationRequired>
    );
}

function Private() {
    const {
        appConfig: { serviceBaseUrl, appId },
    } = useService();
    return (
        <AuthenticationRequired>
            <NavigationLayout
                useLocal={!isProd}
                applicationId={appId}
                logo={headerClientLogo}
                serviceBaseUrl={serviceBaseUrl}
                footerLogo={driveToProfitLogo}
                navigation={{
                    supportPortalLink: SUPPORT_PORTAL_LINK,
                }}
            >
                <Outlet />
            </NavigationLayout>
        </AuthenticationRequired>
    );
}
